module.exports = __webpack_public_path__ + "img/dev.440363e7.svg";